import { Container, Typography } from '@mui/material';
import React from 'react';

function ConfirmEMail() {
	return (
		<Container>
			<Typography variant="h4"> E-Mail-Adresse bestätigen</Typography>
		</Container>
	);
}

export default ConfirmEMail;
